import React from "react";
import { MenuItem, Select } from "@mui/material";
import {
  DesignationTypesForValuation,
  getDesignationTypeTranslation,
} from "../../helpers/comparableFields.helpers";
import { DesignationType } from "common/types/comparableFields.types";
import { useTranslation } from "react-i18next";

interface PropertyTypeSelectorProps {
  selectedType: DesignationType | null | undefined;
  onChange: (type: DesignationType) => void;
  containerStyle?: React.CSSProperties;
}

export const PropertyTypeSelector: React.FC<PropertyTypeSelectorProps> = ({
  selectedType,
  onChange,
  containerStyle,
}) => {
  const { t } = useTranslation();

  const designationTypeOptions = DesignationTypesForValuation.map((type) => ({
    value: type,
    label: getDesignationTypeTranslation(type),
  }));

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        justifyContent: "space-between",
        ...containerStyle,
      }}
    >
      <div>{t("propertyCreation.type.propertyType")}</div>
      <Select
        value={selectedType ?? ""}
        style={{ width: "300px" }}
        onChange={(e) => onChange(e.target.value as DesignationType)}
      >
        {designationTypeOptions.map((designationType) => (
          <MenuItem key={designationType.value} value={designationType.value}>
            {designationType.label}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};
